import { createTheme } from '@mui/material/styles';
import { commonThemeOptions, darkTheme, lightTheme } from './index';
import { getInputComponentOverrides } from './inputSurface';
import { getScrollbarCssBaselineBodyStyles } from './scrollbar';

export function createAppTheme(mode: 'light' | 'dark') {
  const palette = mode === 'dark' ? darkTheme.palette : lightTheme.palette;

  return createTheme({
    ...commonThemeOptions,
    palette,
    components: {
      ...commonThemeOptions.components,
      ...getInputComponentOverrides(commonThemeOptions.components?.MuiSelect),
      MuiCssBaseline: {
        styleOverrides: (theme) => ({
          body: {
            ...getScrollbarCssBaselineBodyStyles(theme),
            backgroundColor: theme.palette.background.default,
            color: theme.palette.text.primary,
          },
          '#root': {
            minHeight: '100vh',
            backgroundColor: theme.palette.background.default,
          },
        }),
      },
      MuiDrawer: {
        styleOverrides: {
          paper: {
            border: 'none',
            boxShadow: '0 0 10px rgba(0,0,0,0.1)',
          },
        },
      },
      MuiAppBar: {
        styleOverrides: {
          root: {
            boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
          },
        },
      },
      MuiDialog: {
        styleOverrides: {
          paper: ({ theme }) => ({
            backgroundColor: theme.palette.background.paper,
            backgroundImage: 'none',
          }),
        },
      },
    },
  });
}
